import { render, staticRenderFns } from "./AncillaryFacility.vue?vue&type=template&id=9ff486fe"
import script from "./AncillaryFacility.vue?vue&type=script&lang=ts"
export * from "./AncillaryFacility.vue?vue&type=script&lang=ts"
import style0 from "./AncillaryFacility.vue?vue&type=style&index=0&id=9ff486fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports